import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// The backend's admin CSRF guard requires this on every write. Only non-GET
// requests get it: those are already CORS-preflighted (JSON body / Bearer
// token), so it costs nothing, whereas adding it to GETs would preflight every
// public catalog read.
api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() !== "get") {
    config.headers["X-Requested-With"] = "XMLHttpRequest";
  }
  return config;
});
